const flowSteps = [
  {
    step: 'STEP 01',
    label: 'ご相談・お見積り',
    title: 'ご相談・お見積り',
    description:
      'お客様の経営課題や問題点をヒアリングし、解決策をご提案いたします。補助率や補助金額についてもわかりやすくご説明いたします。',
  },
  {
    step: 'STEP 02',
    label: '補助金の申請',
    title: '補助金の申請',
    description:
      '補助金公式サイトから申請を行っていただきます。必要書類や書き方など、不明な点はすべてご支援いたします。申請後、IT導入補助金の採択について通知されます。',
  },
  {
    step: 'STEP 03',
    label: '制作〜公開',
    title: '制作〜公開',
    description:
      '発注確認後に制作を開始します。ECサイトの構築が完了しましたら、実際にお客様にご使用いただきます。',
  },
  {
    step: 'STEP 04',
    label: '補助金のお受取り',
    title: '補助金のお受取り',
    description:
      '補助金更新サイトからITツール導入の実績報告をしていただきます。補助金額の確定後、お客様の口座に補助金が交付されます。',
  },
];

const ITSupportFlow = () => {
  return (
    <section className="py-28 bg-[#F8FAF6] relative overflow-hidden" id="flow">
      {/* Background decoration removed */}

      <div className="max-w-5xl mx-auto px-6 lg:px-10 relative">
        <div className="text-center mb-16">
          <p className="text-[#89B56B] text-xs font-semibold tracking-[0.25em] uppercase mb-4 font-['Inter']">
            Subsidy Flow
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-[#89B56B]">
            補助金受取までの流れ
          </h2>
        </div>

        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-6 top-0 bottom-0 w-px bg-[#89B56B]/20 hidden md:block"></div>

          <div className="space-y-10">
            {flowSteps.map((step, index) => (
              <div key={index} className="flex gap-8 items-start group">
                {/* Step number (desktop) */}
                <div className="hidden md:flex flex-col items-center flex-shrink-0">
                  <div className="w-12 h-12 rounded-full bg-[#89B56B] text-white flex items-center justify-center text-sm font-bold font-['Inter'] shadow-[0_4px_16px_rgba(137,181,107,0.3)] relative z-10">
                    {index + 1}
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 bg-white rounded-xl p-8 group-hover:shadow-[0_4px_24px_rgba(137,181,107,0.1)] transition-all duration-300">
                  <div className="flex items-center gap-3 mb-3">
                    {/* Step number (mobile) */}
                    <span className="md:hidden w-8 h-8 rounded-full bg-[#89B56B] text-white flex items-center justify-center text-xs font-bold font-['Inter']">
                      {index + 1}
                    </span>
                    <span className="text-xs text-[#89B56B] font-semibold tracking-wider bg-[#89B56B]/10 px-3 py-1 rounded-full">
                      {step.step}
                    </span>
                  </div>

                  <h3 className="text-lg font-bold text-[#89B56B] mb-3">
                    {step.title}
                  </h3>

                  <p className="text-sm text-gray-600 leading-[1.9]">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default ITSupportFlow;
